import React from "react";
import { Check, X, HelpCircle, Clock } from "lucide-react";
import { cn } from "@/lib/utils";

const STATES = {
  presente:    { label: "Presente",    icon: Check,      cls: "bg-[hsl(var(--state-present-bg))] border-[hsl(var(--state-present)/0.35)] text-[hsl(var(--state-present))]" },
  faltante:    { label: "Faltante",    icon: X,          cls: "bg-[hsl(var(--state-missing-bg))] border-[hsl(var(--state-missing)/0.35)] text-[hsl(var(--state-missing))]" },
  desconocido: { label: "Desconocido", icon: HelpCircle, cls: "bg-[hsl(var(--state-unknown-bg))] border-[hsl(var(--state-unknown)/0.35)] text-[hsl(var(--state-unknown))]" },
  pendiente:   { label: "Pendiente",   icon: Clock,      cls: "bg-muted border-border text-muted-foreground" },
};

export function AnimalStatusChip({ status = "pendiente", className, label, size = "sm" }) {
  const cfg = STATES[status] || STATES.pendiente;
  const Icon = cfg.icon;
  return (
    <span
      data-testid="animal-inventory-status-chip"
      className={cn(
        "inline-flex items-center gap-1.5 rounded-full border font-medium tracking-tight",
        size === "sm" ? "px-2.5 py-0.5 text-[11px]" : "px-3 py-1 text-xs",
        cfg.cls,
        className
      )}
    >
      <Icon size={size === "sm" ? 12 : 14} />
      {label || cfg.label}
    </span>
  );
}
